import React, { Component } from 'react';
import ChildDetailsDialog from '../children/ChildDetailsDialog';
import { withTranslation } from 'react-i18next';
import Card from '../../common/components/Card';
import FontAwesome from 'react-fontawesome';

class AddChildButton extends Component {
    constructor(props) {
        super(props);

        this.showDialog = this.showDialog.bind(this);
        this.hideDialog = this.hideDialog.bind(this);
        this.handleDialogConfirm = this.handleDialogConfirm.bind(this);

        this.state = {
            showDialog: false
        }
    }

    showDialog() {
        this.setState({ showDialog: true });
    }

    hideDialog() {
        this.setState({ showDialog: false });
    }

    handleDialogConfirm(values) {
        const onSuccess = () => this.hideDialog();
        this.props.onConfirm(values, onSuccess);
    }

    render() {
        const { t, requireChildLastName, requireChildSchool, enableParentSelfBooking, hasSameAsParentChild, block, unblock } = this.props;

        return <React.Fragment>
            <a onClick={this.showDialog} style={{ textDecoration: 'none', cursor: 'pointer' }}>
                <Card className='card-dashed' style={{ height: 180, textAlign: 'center', position: 'relative', lineHeight: '120px' }}>
                    <span className='text-muted' style={{ fontSize: 20 }}><FontAwesome name='plus' /> {t('FO_Child_New')}</span>
                </Card>
            </a>
            <ChildDetailsDialog
                child={{ sameAsParent: 'false' }}
                show={this.state.showDialog}
                title={t('FO_Child_New')}
                requireChildLastName={requireChildLastName}
                requireChildSchool={requireChildSchool}
                enableParentSelfBooking={enableParentSelfBooking}
                hasSameAsParentChild={hasSameAsParentChild}
                onConfirm={this.handleDialogConfirm}
                onCancel={this.hideDialog}
                block={block}
                unblock={unblock}
            />
        </React.Fragment>;
    }
}

export default withTranslation()(AddChildButton);